import {
  Close,
  Videocam,
  DescriptionOutlined,
  AutoAwesomeOutlined,
} from '@mui/icons-material';
import {
  Box,
  Container,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { hireflixCta, twitterBlue } from '@styles/colors';
import { FC } from 'react';

type InterviewStyleModalProps = {
  open: boolean;
  onClose: () => void;
};

const interviewStyle = [
  {
    id: 1,
    icon: (
      <DescriptionOutlined
        sx={{ color: twitterBlue, fontSize: '19px', mb: 1 }}
      />
    ),
    title: 'Create From Scratch',
    description: 'Build your interview questions from the ground up',
  },
  {
    id: 2,
    icon: (
      <AutoAwesomeOutlined
        sx={{ color: hireflixCta, fontSize: '19px', mb: 1 }}
      />
    ),
    title: 'Create From Template',
    description: 'Use our pre-built questions to get started quickly',
  },
];

const InterviewStyleModal: FC<
  InterviewStyleModalProps & { onSelect?: (styleId: number) => void }
> = ({ open, onClose, onSelect }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '672px !important',
          backgroundColor: 'rgb(247, 247, 247)',
        },
      }}
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
        <br />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '64px',
            height: '64px',
            margin: '0 auto',
            borderRadius: '100%',
            backgroundColor: 'rgb(243, 232, 255)',
            mb: 5,
          }}
        >
          <Videocam sx={{ fontSize: 40, color: hireflixCta }} />
        </Box>
        <Typography variant="h3" fontWeight="600" sx={{ mb: 8 }}>
          Add New Hireflix Interview
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pb: 9 }}>
        <Container
          disableGutters
          sx={{ maxWidth: '606px !important', width: '100% !important' }}
        >
          <Grid container spacing={3}>
            {interviewStyle.map((item, index) => (
              <Grid item xs={12} sm={6} key={item.id}>
                <Box
                  sx={{
                    bgcolor: '#ffffff',
                    borderRadius: 8,
                    px: 3,
                    py: 1.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.5,
                    textAlign: 'center',
                    padding: '24px 32px',
                    border: '2px solid rgb(242, 242, 242)',
                    transitionProperty: 'color, background-color, border-color',
                    transitionTimingFunction: 'cubic-bezier(.4,0,.2,1)',
                    transitionDuration: '.35s',
                    cursor: 'pointer',
                    '& h2': { transition: 'color 0.35s ease' },
                    '&:hover': {
                      boxShadow:
                        'rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px',
                      borderColor: index === 0 ? twitterBlue : hireflixCta,
                      backgroundColor:
                        index === 0
                          ? 'rgba(0, 157, 255, 0.1)'
                          : 'rgb(243, 232, 255)',
                      '& h2': {
                        color: index === 0 ? twitterBlue : hireflixCta,
                      },
                    },
                  }}
                  onClick={() => {
                    if (onSelect) onSelect(item.id);
                  }}
                >
                  <Box>
                    {item.icon}

                    <Typography
                      fontSize="15px"
                      variant="h2"
                      fontWeight="600"
                      mb={1}
                    >
                      {item.title}
                    </Typography>

                    <Typography variant="body2" fontSize="12px" color="#737373">
                      {item.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </DialogContent>
    </Dialog>
  );
};

export default InterviewStyleModal;
